module.exports = "data:image/gif;base64,R0lGODlhEAAQANUiADk5OT09PTU1NVBQUDc3N3BwcDAwMEBAQENDQ2RkZE9PTzs7Ozo6OjY2Nj4+PldXVy4uLjw8PC0tLS8vL05OTmhoaElJSWVlZWBgYGFhYV9fXywsLDg4OGJiYkRERHJyckVFRWlpaQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAACIALAAAAAAQABAAAAZEQJFwSCwaj8ikckksBACh5WegQDASycLgQUEEBNijg2o5LAgTJADkOTwFEGRlEYgAGoZM8kLgCAwaSx0SGxhMh4iJikEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/menu/group-checked.gif
 ** module id = 439
 ** module chunks = 0
 **/